import * as React from 'react'; // https://github.com/parcel-bundler/parcel/issues/1199
import * as propTypes from 'prop-types';
import VirtualList, { ItemStyle } from 'react-tiny-virtual-list';
import { ALIGNMENT } from 'react-tiny-virtual-list/types/constants';
import { FormSelectChoice } from '../../../../lib/types/types';


interface SelectListProps {
    getItemProps: any;
    getMenuProps: any;
    highlightedIndex: number;
    itemToString: any;
    options: FormSelectChoice[];
}

const ROW_HEIGHT = 42;
const AUTO_SCROLL = 'auto' as ALIGNMENT.AUTO;

const SelectList = ({ getItemProps, getMenuProps, highlightedIndex, options, itemToString }: SelectListProps) => {
    const fullHeight = options.length * ROW_HEIGHT;
    const itemCount = options.length;

    const item = (index: number, style: ItemStyle) => {
        return (
            <div
                className={`sid-select-list__item ${highlightedIndex === index ? 'sid-select-list__item--highlighted' : ''}`}
                key={options[index].value}
                {...getItemProps({
                    style,
                    index,
                    item: options[index],
                })}
                >
                {itemToString(options[index])}
            </div>
        );
    };

    return(
        <VirtualList
            {...getMenuProps()}
            className={'sid-select-list__menu'}
            height={Math.min(fullHeight, 280)}
            itemCount={itemCount}
            itemSize={ROW_HEIGHT}
            renderItem={({ index, style }) => item(index, { ...style, width: 'auto' })}
            scrollToAlignment={AUTO_SCROLL}
            scrollToIndex={highlightedIndex || 0}
            tabIndex={-1}
            width={'100%'}
        />
    );
};

SelectList.propTypes = {
    getItemProps: propTypes.func.isRequired,
    getMenuProps: propTypes.func.isRequired,
    itemToString: propTypes.func.isRequired,
    highlightedIndex: propTypes.number.isRequired,
    options: propTypes.array.isRequired,
};

export const SelectListComponent = SelectList;
